var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wrapper",
      class: {
        "wrapper--busy": _vm.isInitialized && _vm.busy,
      },
    },
    [
      !_vm.isInitialized && _vm.busy
        ? _c("Loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.busy,
              height: "300",
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isInitialized,
              expression: "isInitialized",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _vm.positions.length > 2
                ? _c("Switcher", {
                    staticClass: "h-switcher",
                    attrs: { type: "group", items: _vm.positions },
                    model: {
                      value: _vm.currentPosition,
                      callback: function ($$v) {
                        _vm.currentPosition = $$v
                      },
                      expression: "currentPosition",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c("Input", {
                    ref: "periodRef",
                    staticClass: "filters__period",
                    attrs: {
                      label: "Период",
                      placeholder: "00.00.0000 - 00.00.0000",
                      type: "period",
                      icon: "calendar",
                      clearable: true,
                      "icon-right": true,
                    },
                    model: {
                      value: _vm.periodText,
                      callback: function ($$v) {
                        _vm.periodText = $$v
                      },
                      expression: "periodText",
                    },
                  }),
                  _c("Button", {
                    staticClass: "filters__apply",
                    attrs: { label: "Применить", color: "primary" },
                    on: { click: _vm.setPeriod },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "ScrolledTable",
            { staticClass: "desktop", attrs: { "fix-last": true } },
            [
              _c(
                "table",
                {
                  staticClass:
                    "h-table inventory-history inventory-history--desktop",
                },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      _vm._l(_vm.tableHeaders, function (header) {
                        return _c(
                          "th",
                          {
                            key: `header_${header.key}`,
                            style: {
                              width: header.width ? `${header.width}px` : null,
                            },
                          },
                          [
                            _c("TableHeader", {
                              attrs: {
                                header: header,
                                "sort-by": _vm.filters.sortBy,
                                "sort-dir": _vm.filters.sortDir,
                              },
                              on: {
                                "update:sortBy": function ($event) {
                                  return _vm.$set(_vm.filters, "sortBy", $event)
                                },
                                "update:sort-by": function ($event) {
                                  return _vm.$set(_vm.filters, "sortBy", $event)
                                },
                                "update:sortDir": function ($event) {
                                  return _vm.$set(
                                    _vm.filters,
                                    "sortDir",
                                    $event
                                  )
                                },
                                "update:sort-dir": function ($event) {
                                  return _vm.$set(
                                    _vm.filters,
                                    "sortDir",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.entriesByPosition, function (entry) {
                      return _c(
                        "tr",
                        {
                          key: entry.key,
                          staticClass: "history-item h-table__row",
                        },
                        [
                          _vm.positions.length > 2
                            ? _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.printEntryPositions(entry) || "—"
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "td",
                            [
                              entry.item.id
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "name-cell",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showEntryHistory(entry)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(entry.item.serialNumber) +
                                          " / " +
                                          _vm._s(entry.item.name || "—") +
                                          " "
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "name-cell__type" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(entry.item.type.name) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : [_vm._v(" — / — ")],
                            ],
                            2
                          ),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(entry.item.type.model || "—") +
                                " / " +
                                _vm._s(entry.item.model || "—") +
                                " "
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (entry.item.category &&
                                    entry.item.category.name) ||
                                    "—"
                                ) +
                                " / " +
                                _vm._s(
                                  (entry.item.subcategory &&
                                    entry.item.subcategory.name) ||
                                    "—"
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", [_vm._v(" " + _vm._s(entry.status) + " ")]),
                          _c("td", [_vm._v(" " + _vm._s(entry.date) + " ")]),
                          _c(
                            "td",
                            [
                              entry.author.worker
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `/index.php/?r=redesign#/personal-employee/${entry.author.worker.id}/summary`,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(entry.author.worker.name) +
                                          " "
                                      ),
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      " " + _vm._s(entry.author.user.name) + " "
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _c(
                            "td",
                            [
                              entry.item.responsible
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `?r=redesign#/personal-employee/${entry.item.responsible.id}/summary`,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(entry.item.responsible.name) +
                                          " "
                                      ),
                                    ]
                                  )
                                : [_vm._v(" — ")],
                            ],
                            2
                          ),
                          _c(
                            "td",
                            [
                              _c("EntryControls", {
                                attrs: { entry: entry },
                                on: {
                                  showComment: _vm.showEntryComment,
                                  showInfo: _vm.showEntryInfo,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
          _c("HorizontalTable", { staticClass: "mobile" }, [
            _c(
              "table",
              { staticClass: "h-table h-table--horizontal" },
              _vm._l(_vm.tableHeaders, function (header) {
                return _c(
                  "tr",
                  { key: header.key },
                  [
                    _c(
                      "th",
                      [
                        _c("TableHeader", {
                          attrs: {
                            header: header,
                            "sort-by": _vm.filters.sortBy,
                            "sort-dir": _vm.filters.sortDir,
                          },
                          on: {
                            "update:sortBy": function ($event) {
                              return _vm.$set(_vm.filters, "sortBy", $event)
                            },
                            "update:sort-by": function ($event) {
                              return _vm.$set(_vm.filters, "sortBy", $event)
                            },
                            "update:sortDir": function ($event) {
                              return _vm.$set(_vm.filters, "sortDir", $event)
                            },
                            "update:sort-dir": function ($event) {
                              return _vm.$set(_vm.filters, "sortDir", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._l(_vm.entriesByPosition, function (entry) {
                      return _c(
                        "td",
                        { key: entry.key },
                        [
                          header.key === "controls"
                            ? _c("EntryControls", {
                                attrs: { entry: entry },
                                on: {
                                  showComment: _vm.showEntryComment,
                                  showInfo: _vm.showEntryInfo,
                                },
                              })
                            : header.key === "positions"
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.printEntryPositions(entry) || "—"
                                    ) +
                                    " "
                                ),
                              ]
                            : header.key === "guid"
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "name-cell",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showEntryHistory(entry)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(entry.item.serialNumber) +
                                        " / " +
                                        _vm._s(entry.item.name || "—") +
                                        " "
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "name-cell__type" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(entry.item.type.name) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : header.key === "model"
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(entry.item.type.model || "—") +
                                    " / " +
                                    _vm._s(entry.item.model || "—") +
                                    " "
                                ),
                              ]
                            : header.key === "category"
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (entry.item.category &&
                                        entry.item.category.name) ||
                                        "—"
                                    ) +
                                    " / " +
                                    _vm._s(
                                      (entry.item.subcategory &&
                                        entry.item.subcategory.name) ||
                                        "—"
                                    ) +
                                    " "
                                ),
                              ]
                            : header.key === "author"
                            ? [
                                entry.author.worker
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: `/index.php/?r=redesign#/personal-employee/${entry.author.worker.id}/summary`,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(entry.author.worker.name) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(entry.author.user.name) +
                                          " "
                                      ),
                                    ],
                              ]
                            : header.key === "responsible"
                            ? [
                                entry.item.responsible
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: `?r=redesign#/personal-employee/${entry.item.responsible.id}/summary`,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              entry.item.responsible.name
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : [_vm._v(" — ")],
                              ]
                            : [
                                _vm._v(
                                  " " + _vm._s(entry[header.key] || "—") + " "
                                ),
                              ],
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
          !_vm.entries.length
            ? _c(
                "div",
                { staticClass: "empty" },
                [
                  _vm.hasFilters
                    ? [_vm._v(" Записи не найдены ")]
                    : [_vm._v(" Изменений пока нет ")],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c("HistorySidesheet", { ref: "historySidesheet" }),
      _c("InfoSidesheet", { ref: "infoSidesheet" }),
      _c("CommentModal", { ref: "commentModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }